document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll(".js-accordion-trigger");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const body = trigger.nextElementSibling;
      const isOpen = trigger.classList.contains("is-open");

      if (isOpen) {
        body.style.maxHeight = body.scrollHeight + "px";
        requestAnimationFrame(() => {
          body.style.maxHeight = "0px";
        });
        trigger.classList.remove("is-open");
        body.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
      } else {
        body.style.maxHeight = body.scrollHeight + "px";
        trigger.classList.add("is-open");
        body.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      }
    });
  });
});
